export const projects = [
  {
    "id": 1,
    "title": "Debona Jewels",
    "subtitle": "E-commerce",
    "description": "Jewels with soul. Authentic, timeless & inimitable designs made with 3D tech & handfinished",
    "details": "The Debona Project was born on 2017 with a Shopify e-commerce -no longer available-. During quarentinee the brand, the feel and look and the website where updated to the current site, build with Wordpress. At the beggining of 2021 we started designing a new site with React, Node, Express & Mongo that will be available soon!",
    "year": "2017, 2019, 2021",
    "tech": "Shopify & Wordpress. Available soon in React!",
    "image": "debona.png",
    "url": "https://debonajewels.com/",
    "github-repo": ""
  },
  {
    "id": 2,
    "title": "Sound Mist",
    "subtitle": "Music everywhere",
    "description": "Awesome music platform. Upload and listen your favourite songs and artists!",
    "details": "Soundmist was a challenging and successful project. The frontend is build using React, JavaScript, HTML & CSS, as well as some extra libraries such as React-Toastify, react-h5-audio-player or MaterialUI for a few components; we analysed some of the best music apps to improve the user experience and offer new and different features. The backend is build with JavaScript, Node, Express, Mongo, Mongoose",
    "year": "2021",
    "tech": "React, Node, MongoDB, Express & Mongoose",
    "image": "soundmist.png",
    "url": "https://soundmist.netlify.app/",
    "github-repo": "https://github.com/PabloIraburu/soundcloud-front"
  },
  {
    "id": 3,
    "title": "Iris Therapy",
    "subtitle": "Grow, learn & evolve",
    "description": "A site for personal growth and development. Therapies, trainings and events",
    "details": "",
    "year": "2018",
    "tech": "Squarespace",
    "image": "iristherapy.png",
    "url": "https://www.iristherapy.org/",
    "github-repo": ""
  },
  {
    "id": 4,
    "title": "TinDog",
    "subtitle": "Pet Lovers",
    "description": "The opportunity for our pets to love and be loved. The best app ever, available for IOS & Android",
    "details": "",
    "year": "2020",
    "tech": "HTML & CSS & Bootstrap",
    "image": "tindog.png",
    "url": "https://cristinapicatoste.github.io/tinDog/",
    "github-repo": "https://github.com/cristinapicatoste/tinDog"
  },
  {
    "id": 5,
    "title": "Project 22",
    "subtitle": "Numerology Calculator",
    "description": "Your numerology in a few seconds, the bridge between who you are now and who you can become",
    "details": "",
    "year": "2020",
    "tech": "JavaScript, HTML & CSS & MaterialUI",
    "image": "newproject22.png",
    "url": "https://cristinapicatoste.github.io/numerology_calculator/",
    "github-repo": "https://github.com/cristinapicatoste/numerology_calculator"
  },

]